<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap class="mt-3">
      <v-flex xs12>
        <Stepper step="1"></Stepper>
      </v-flex>

      <v-flex xs12 sm12 md6>
        <v-card>
          <NewAddress
            ref="origin"
            :title="$t('origin')"
            addressType="origin"
            :countries="countries"
            :settings="settings"
            :disableEmail="disableEmail"
            :disablePhone="disablePhone"
            :defaultRFC="originRfc"
            ></NewAddress>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <v-card>
          <NewAddress
            ref="destination"
            :title="$t('destination')"
            addressType="destination"
            :countries="countries"
            :settings="settings"
            :disableEmail="disableEmail"
            :disablePhone="disablePhone"
            :defaultRFC="destinationRfc"
            ></NewAddress>
        </v-card>
      </v-flex>

      <v-flex xs12 class="text-xs-right">
        <v-btn color="primary" flat @click="goTo('shipments')" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" @click="submit" :loading="loading">
          {{ $t('saveContinue') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shipment from '@/client/shipment'
import Country from '@/client/country'
import Setting from '@/client/setting'
import Preference from '@/client/preference'

import Stepper from '@/components/shipments/stepper'
import NewAddress from '@/components/shipments/new-address'

export default {
  name: 'ShipmentFormView',

  props: {},

  data () {
    return {
      loading: false,
      shipment: {},
      countries: [],
      originCountries: [],
      originAddresses: [],
      preferences: [],
      settings: [],
      disablePhone: false,
      disableEmail: false,
    }
  },

  components: {
    Stepper,
    NewAddress
  },

  computed: {
    originRfc () {
      const pref = this.preferences.find(o => o.key === 'origin_rfc')
      if (!pref) { return '' }

      return pref.value
    },

    destinationRfc () {
      const pref = this.preferences.find(o => o.key === 'destination_rfc')
      if (!pref) { return '' }

      return pref.value
    },
  },

  methods: {
    async submit () {
      this.spanishizeAddress('origin')
      this.spanishizeAddress('destination')

      const validOrigin = await this.$refs.origin.$validator.validateAll()
      const validDest = await this.$refs.destination.$validator.validateAll()
      if (!validOrigin || !validDest) { return }

      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.shipment.origin_attributes = { ...this.$refs.origin.address }
        this.shipment.destination_attributes = { ...this.$refs.destination.address }

        this.shipment.save_origin = this.$refs.origin.address.save
        this.shipment.save_destination = this.$refs.destination.address.save

        await this.shipment.save()
        this.goTo('newParcel', { shipmentId: this.shipment.id })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    spanishizeAddress (addressType) {
      const keys = ['name', 'company', 'email', 'reference', 'street', 'neighborhood', 'city']

      for( let i = 0; i < keys.length; ++i ) {
        if (this.$refs[addressType].address[keys[i]]){
          this.$refs[addressType].address[keys[i]] = this.$refs[addressType].address[keys[i]].spanishize()
        }
      }
    }
  },

  watch: {
  },

  async mounted () {
    this.shipment = new Shipment()

    this.settings = await Setting.all()

    try {
      this.disableEmail = this.settings.find(o => o.key === `disable_email`).value == '1'
      this.disablePhone = this.settings.find(o => o.key === `disable_phone_number`).value == '1'
    } catch (err) {}

    this.countries = await Country.all({ per_page: 2000, order: 'name ASC', fast_search: true })
    this.preferences = await Preference.all()
  }
}
</script>
